import { useCallback, useState } from "react"

const useToggle = (initialState = false) => {
  const [show, setShow] = useState(initialState)
  const toggle = useCallback(() => setShow((prevShow) => !prevShow), [])
  return [show, toggle] as const
}

export default useToggle
